<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    //
  }),
};
</script>

<style>
.theme--dark.v-text-field > .v-input__control > .v-input__slot::before {
  border-color: rgba(0, 255, 255, 0.3) !important;
}
.theme--dark .v-input__append-inner {
  color: #00ffff !important;
}
.theme--dark.v-select .v-select__selections {
  color: #00ffff !important;
}

.theme--dark.v-input input,
.theme--dark.v-input textarea {
  color: #00ffff !important;
}

.theme--dark.v-label--is-disabled {
  color: #00ffff !important;
}

.theme--light.v-label--is-disabled {
  color: #fa7c10 !important;
}

/* Make dropdown list options and selection texts slightly smaller and more compact */
.v-select__selection,
.v-select__selections,
.v-select .v-label {
  font-size: 0.9rem !important;
}

.v-menu__content .v-list-item__title {
  font-size: 0.85rem !important;
}
</style>
